// extracted by mini-css-extract-plugin
module.exports = {"container":"LockDown_container__39K43","tel":"LockDown_tel__3Unhb","type":"LockDown_type__2VOFD"};